import type { UserRole } from '../types';

/**
 * Single-role access checks. The role comes from `users/{uid}.role` and is the
 * only authorization key (mirrored by firestore.rules).
 */

/** May create/edit operational company data: customers, documents, cases. */
export function canWorkOrgData(role: UserRole | null | undefined): boolean {
  return role === 'internal_admin' || role === 'client_admin' || role === 'client_user';
}

/** May manage the organization itself: settings, members, branding, audit log, publish. */
export function isOrgAdmin(role: UserRole | null | undefined): boolean {
  return role === 'internal_admin' || role === 'client_admin';
}

/** Craftin platform staff — global catalogs and cross-tenant access. */
export function isInternalAdmin(role: UserRole | null | undefined): boolean {
  return role === 'internal_admin';
}
